import { render, staticRenderFns } from "./AvailablePaymentInInstallment.vue?vue&type=template&id=5983624d"
import script from "./AvailablePaymentInInstallment.vue?vue&type=script&lang=js"
export * from "./AvailablePaymentInInstallment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports